import { useEffect, useState } from "react";
import { Modal as AntModal } from "antd";
import { eventBus } from "@Utils/EventBus";
import { CLOSE_MODAL, OPEN_MODAL } from "@Constants/modal";


interface ModalData {
    content: React.ReactNode;
  }

const Modal = () => {
  const [visible, setVisible] = useState<boolean>(false);
  const [content, setContent] = useState<React.ReactNode>(null);

  useEffect(() => {
    const openModal = (data: ModalData) => {
      console.log('data', data)
      setContent(data.content);
      setVisible(true);
    };

    const closeModal = () => {
      setVisible(false);
      setContent(null);
    };

    // Subscribe to the events
    eventBus.subscribe(OPEN_MODAL, openModal);
    eventBus.subscribe(CLOSE_MODAL, closeModal);

    // Clean up on component unmount
    return () => {
      eventBus.unsubscribe(OPEN_MODAL, openModal);
      eventBus.unsubscribe(CLOSE_MODAL, closeModal);
    };
  }, []);

  return (
    <AntModal
      title=""
      open={visible}
      closable={false}
      onCancel={() => {
        setVisible(false);
        setContent(null);
      }}
      footer={null}
    >
      {content}
    </AntModal>
  );
};

export default Modal;
